export const DEFAULT_TOOLBAR = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: '' }, { align: 'center' }, { align: 'right' }],
  [{ color: [] }, { background: [] }],
  [{ indent: '-1' }, { indent: '+1' }],
  ['link'],
] as (string[] | Record<string, unknown>[])[];

/**
 * Embed types that are unconditionally blocked from Quill content.
 * These are XSS vectors via known Quill CVEs.
 */
export const BLOCKED_EMBED_TYPES = ['image', 'formula', 'video'] as const;

export type BlockedEmbedType = (typeof BLOCKED_EMBED_TYPES)[number];
